export const IsLoadingActiveRound = state => state.super6Extra.isLoading;

export const HasLoadedActiveRound = state => state.super6Extra.hasLoaded;

export const GetSuper6ExtraActiveRound = state => state.super6Extra.activeRound;
